import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('cart-discount-messaging')
class CartDiscountMessaging extends LitElement {
  createRenderRoot() {
    return this;
  }

  connectedCallback() {
    super.connectedCallback();
    const value = `; ${document.cookie}`;
    const parts = value.split(`; discount_code=`);
    const cookieValue = parts.pop().split(';').shift();
    if (cookieValue) {
      this.classList.add('!block');
    }
  }

  render() {
    return html` <slot></slot> `;
  }
}

export default CartDiscountMessaging;
